import React, { useEffect, useState } from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";
import CiudadanosService from "../services/CiudadanosService";


const TelemedicinaSites = () => {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [turnos, setTurnos] = useState([]);


    useEffect(()=> {
        CiudadanosService.getTurnosCiudadanos(localStorage.getItem("hashLogin"))
        .then((resp=> {
            console.log(resp.data);
            setTurnos(resp);
            setLoading(false);
        }))
        .catch((error)=>{
            console.log(error);
setTurnos({data:[]});
            setLoading(false);
        })
        setLoading(true);
    },[])

    function compare ( a, b) {
        if ( a.Fecha  < b.Fecha)
        return -1
        else if (a.Fecha > b.Fecha)
        return 1;
        else if (a.Hora < b.Hora)
        return -1;
        else if (a.Hora > b.Hora)
        return 1;
        else 
        return 0;
    }

    const turnoClick = (el) => {
        localStorage.setItem("Canc-IdTurno", el.IdTurno);
        localStorage.setItem("Canc-Agenda", el.Agenda);
        localStorage.setItem("Canc-Doctor", el.Doctor);
        localStorage.setItem("Canc-Lugar", el.Lugar);
        localStorage.setItem("Canc-Especialidad", el.Especialidad);
        localStorage.setItem("Canc-Fecha", el.Fecha);
        localStorage.setItem("Canc-Hora", el.Hora);
        navigate("/telemedicinaview");
    }
    
    return (
        
       
       <div class="container text-center mainContent" >
        <PageTitles texto="Mis Turnos"  icono="./icon_header_turnos.svg" retorno="/turnos"/>
{
    !loading?
    turnos.data.length>0?
    turnos.data.sort(compare).map(x => { return (
    <>
    <div class="row" onClick={()=>turnoClick(x)}>    
    <div class="col-3" style={{textAlign:"right"}}> 
    <img src="./icon-turno.svg" width="30px"/>
    </div>
    <div class="col miniTitle itemMiTurno">
    {x.Especialidad} </div>
    </div><div class="row"><div class="col-3"></div>
    <div class="col-9 textGrey textLeft">{CiudadanosService.convertir(x.Fecha)} - {x.Hora} hs.</div>
    </div><div class="row"><div class="col-3"></div>
    <div class="col-9 textGrey textLeft"> {x.Lugar}</div>
<div>
    <img src="./line.png" width="250px"/>
</div>
    </div>

    </>
    )}):<div class="col miniTitle">No hay turnos pendientes</div>:<div class="col miniTitle">Cargando...</div>
    
    
}

       </div>
        
        
        

    );
    }
export default TelemedicinaSites;